export function updateStyleProperty(style: string, key: string, value: string | null): string {
    const parts = style
        .split(';')
        .map((p) => p.trim())
        .filter(Boolean);
        
    const other = parts
        .filter((p) => !p.startsWith(`${key}:`))
        .join('; ');

    if (value === null) {
        return other;
    }

    const updated = other ? `${other}; ${key}: ${value};` : `${key}: ${value};`;
    return updated;
}